<template>
  <oshirase-list></oshirase-list>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import OshiraseList from "@/components/oshirase/List.vue";

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      "oshirase-list": OshiraseList,
    }
})
</script>
